import * as rive from "@rive-app/canvas";
import * as PIXI from 'pixi.js';



import { ConfigType } from "@game/Config";
import { getBaseURL, getFileExtension, getParameterByName, hideElement, showElement } from "@utils/helpers";
import { App } from "./App";


export class SplashManager {
  loader: HTMLDivElement;

  resources: any;
  config: ConfigType;


  constructor(config: ConfigType) {
    this.config = config;
    this.resources = {};


    this.loader = document.getElementById('loader') as HTMLDivElement
    const LoadingURL = `${getBaseURL()}/${getParameterByName("loading") ?? "/public/imoon-logo.svg"}`
    const ext = getFileExtension(LoadingURL);

    const container = document.querySelector(".loader-container") as HTMLCanvasElement
    if (!container) return;

    if (ext == "riv") {
      try {
        const child = document.createElement("canvas");
        child.id = "canvas-loader"
        container.prepend(child)
        const url = LoadingURL
        rive.RuntimeLoader.setWasmUrl(`${getBaseURL()}/public/assets/loading/rive.wasm`);
        const r = new rive.Rive({
          src: url,
          canvas: child,
          stateMachines: "Timeline 1",
          autoplay: true,
          onLoad: () => {
            r.resizeDrawingSurfaceToCanvas();
          },
        });
      } catch (e: any) {
        console.log("Rive Load Error")
      }
    } else {
      const child = document.createElement("img");
      child.id = "canvas-loader"
      child.src = LoadingURL
      container.prepend(child)
    }
    const showExclusive = getParameterByName("exclusive");
    const powerBy = document.querySelector("#poweredBySvg") as HTMLElement
 
    if (!!showExclusive) {
      hideElement(powerBy)
    } else {
      showElement(powerBy)

    }

   

    this.simulateLoadingProgress(1000)
  }


  resize() {
    const container = this.loader.querySelector(".loader-container") as HTMLElement;
    if (container) container.style.scale = `${window.innerWidth < 450 ? ((window.innerWidth - 68) / 372) : 1}`
      container.style.opacity = '1'
  }



  hideLoader() {

    this.loader.classList.add('hide')

  }




  handleLoadingProgressChange(eventProgress: number) {
    const progress = Math.round(eventProgress * 100); // Get progress percentage
    const progressBar = this.loader.querySelector("#progress") as HTMLElement;
    // const progressText = this.loader.querySelector('#progress-text') as HTMLSpanElement
    // progressText.style.fontFamily = 'Verdana, Geneva, Tahoma, sans-serif'
    // progressText.innerHTML = `${progress}%`
    if (!progressBar) return;
    progressBar.style.width = progress + "%";
  }


  simulateLoadingProgress(duration: number = 2000) {
    const startTime = performance.now();
    const progressBar = this.loader.querySelector("#progress") as HTMLElement;
    if (!progressBar) return;

    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Apply progress
      const percent = Math.floor(progress * 100);
      progressBar.style.width = `${percent}%`;

      // Optionally: Call existing handler if used elsewhere
      this.handleLoadingProgressChange(progress);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }

}